import { Button } from "@ths/ui";

interface Props {
  onDone: () => void;
}

export default function ConfirmationStep({ onDone }: Props) {
  return (
    <div className="bc-fade-up w-full max-w-md space-y-6 text-center">
      <div className="mx-auto flex size-16 items-center justify-center rounded-full border border-success bg-success-surface text-3xl text-success-text">
        ✓
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-text">Request received</h1>
        <p className="text-sm text-text-secondary">
          A staff member will review it shortly. You may close this window.
        </p>
      </div>
      <Button type="button" onClick={onDone} variant="link">
        Done
      </Button>
    </div>
  );
}
